import React from 'react';
import { Col, Form, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
const CommonFolderBody = _ref => {
  let {
    body,
    setBody
  } = _ref;
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/React.createElement(Form.Group, {
    className: "mb-2",
    as: Row
  }, /*#__PURE__*/React.createElement(Form.Label, {
    column: "md",
    md: 3
  }, t('name')), /*#__PURE__*/React.createElement(Col, {
    md: {
      span: 5,
      offset: 4
    }
  }, /*#__PURE__*/React.createElement(Form.Control, {
    name: "name",
    value: body.name,
    size: "md",
    type: "text",
    onChange: e => {
      setBody(body => ({
        ...body,
        name: e.target.value
      }));
    }
  })));
};
export default CommonFolderBody;